import { useEffect, useState } from "react"
import moment from "moment"
import { Card } from "@/components/ui/card"
import { Loader2 } from "lucide-react"

const SapCountdown = () => {
  const [timeLeft, setTimeLeft] = useState<{
    hours: number
    minutes: number
    seconds: number
  }>({ hours: 0, minutes: 0, seconds: 0 })
  const [isRedirecting, setIsRedirecting] = useState(false)

  useEffect(() => {
    const targetDateStr = `2026-04-01T08:00:00+07:00`
    const targetTime = moment(targetDateStr)

    const calculateTimeLeft = () => {
      const now = moment()
      const difference = targetTime.diff(now)

      if (difference <= 0) {
        setIsRedirecting(true)
        window.location.replace("https://my436551.s4hana.cloud.sap/ui#Shell-home")
        return { hours: 0, minutes: 0, seconds: 0 }
      }

      const duration = moment.duration(difference)
      return {
        hours: Math.floor(duration.asHours()),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      }
    }

    setTimeLeft(calculateTimeLeft())

    const timer = setInterval(() => {
      const remainingResult = calculateTimeLeft()
      setTimeLeft(remainingResult)

      // Stop interval if redirecting to avoid unnecessary calculation
      if (isRedirecting) clearInterval(timer)
    }, 1000)

    return () => clearInterval(timer)
  }, [isRedirecting])

  return (
    <div className="min-h-[80vh] flex flex-col justify-center items-center p-5 bg-[url('https://assets.tokopedia.net/assets-tokopedia-lite/v2/zeus/kratos/149df038.svg')] bg-no-repeat bg-center bg-cover">
      <Card className="w-full max-w-[500px] rounded-[24px] shadow-[0_10px_30px_rgba(0,0,0,0.1)] border-none text-center overflow-hidden">
        <div className="mb-[30px] mt-[10px] flex flex-col items-center">
          <img
            src="/assets/icons/ic_sap-icon.svg"
            alt="SAP Production Logo"
            className="w-20 h-20 object-contain"
            onError={e => {
              // Fallback jika tidak menemukan file aslinya
              e.currentTarget.style.display = "none"
            }}
          />
          <h3 className="text-primary mt-4 mb-0 text-2xl font-bold">SAP Production</h3>
          <p className="text-slate-500 text-base mt-2">SAP is preparing to Go Live</p>
        </div>

        {isRedirecting ? (
          <div className="py-10 flex flex-col items-center flex-1">
            <Loader2 className="animate-spin text-primary mb-4 h-12 w-12" />
            <div className="mt-5 mb-2 text-primary text-lg font-bold">Redirecting to SAP...</div>
            <span className="text-slate-500 block">Please wait while we securely connect you to SAP Production</span>
          </div>
        ) : (
          <div className="px-6 pb-6">
            <div className="flex justify-center gap-4 my-[30px]">
              <TimeBox value={timeLeft.hours} label="Hours" />
              <TimeBox value={timeLeft.minutes} label="Minutes" />
              <TimeBox value={timeLeft.seconds} label="Seconds" />
            </div>

            <div className="p-4 bg-slate-50 rounded-xl mt-5">
              <span className="text-slate-500 text-sm">
                SAP Production Go-Live will be at
                <br />
                <strong className="text-slate-800 text-base font-bold">08:00 WIB</strong>
              </span>
            </div>
          </div>
        )}
      </Card>
    </div>
  )
}

const TimeBox = ({ value, label }: { value: number; label: string }) => (
  <div className="flex flex-col items-center w-20">
    <div className="bg-gradient-to-br from-primary-600 to-primary-500 text-white text-4xl font-bold w-full h-[80px] flex justify-center items-center rounded-2xl shadow-[0_8px_16px_rgba(24,128,56,0.2)]">{String(value).padStart(2, "0")}</div>
    <span className="mt-[10px] text-slate-500 text-[13px] uppercase tracking-[1px] font-bold">{label}</span>
  </div>
)

export default SapCountdown
// test deploy